// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"0b89c126","744":"d61bdbb0","869":"72c0416b","978":"c4d362b6"}[chunkId] + ".css";
};